var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.isApply)?_c('Button',{staticClass:"btn-apply-teacher",attrs:{"name":_vm._name},on:{"handleClick":_vm.handleClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }